import GlobalBanner from "./GlobalBanner"
export * from "./GlobalBanner"
export default GlobalBanner
